module.exports = __webpack_public_path__ + "img/thumb-harpies.2330e412.jpg";